/* @flow */

import { Field } from 'formik';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './RadioButton.style';

type Props = {
  name: string,
  value: string,
  text: string,
};

const useStyles = createUseStyles(styles);

const RadioButton = ({ value, name, text }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <span className={classes.root}>
      <Field
        id={value}
        name={name}
        type="radio"
        component="input"
        value={value}
      />
      <label className={classes.label} htmlFor={value}>
        {text}
      </label>
    </span>
  );
};

export default compose(React.memo)(RadioButton);
